export const MODAL_TYPES = {
  placeOrder: 'placeOrder',
  addProtection: 'addProtection',
  closePosition: 'closePosition',
  cancelOrder: 'cancelOrder',
  editOrder: 'editOrder',
  createPriceAlert: 'createPriceAlert',
  addFunds: 'addFunds',
  accountStatement: 'accountStatement',
  deleteAlert: 'deleteAlert',
  settings: 'settings',
  statistics: 'statistics',
  myHistory: 'myHistory',
  resultChallenge: 'resultChallenge',
} as const;
